import { StandardStrapiFields } from '../strapi/strapi'
import Machine from './machine'
import PrintJob from './print-job'

export default interface PrintQueueEntry extends StandardStrapiFields {
    zone?: Zones
    print_job?: PrintJob
    machine?: Machine
    sort: number
    executionOrder?: number
    plannedPrintDate?: string | null
    comment?: string

    stampPrepared?: boolean
    formsPrepared?: boolean
    blankPrepared?: boolean
    paintsPrepared?: boolean
}


export enum Zones {
    Main = 'Основная',
    Waiting = 'Ожидание',
}
